import React from "react";
import propTypes from "prop-types";
import clsx from "clsx";
import { SnackbarContent, IconButton } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";

import useStyles from "./stylesSnackbar";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const SnackbarContentWrapper = ({
  className,
  message,
  onClose,
  variant,
  ...other
}) => {
  const classes = useStyles();
  const Icon = variantIcon[variant];
  return (
    <SnackbarContent
      className={clsx(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={clsx(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="close"
          color="inherit"
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
};

SnackbarContentWrapper.propTypes = {
  className: propTypes.string,
  message: propTypes.string,
  onClose: propTypes.func,
  variant: propTypes.string,
  other: propTypes.object
};

export default SnackbarContentWrapper;
